import notice from './notice'
import noticePerson from './noticePerson'
import deptExtendInfo from "@/api/notice/deptExtendInfo";

const NoticeServer = {
    notice,
    noticePerson,
    deptExtendInfo,
};

export default NoticeServer;
